import router from '@/router'
// import { Message } from 'element-ui'
import { message } from '@/utils/resetMessage'
export function handlerHttpError (res) {
  switch (res.code) {
    case 50001: // 非法token
      if (res.message) {
        message.error(res.message)
      }
      router.push('/login')
      break
    default:
      if (res.message) {
        message.error(res.message)
      }
      break
  }
}
